import { useFlag } from '@/features/unleash';
import loadable from '@loadable/component';

const PortfolioCta = loadable(() => import('./PortfolioCta'), {
  resolveComponent: (c) => c.PortfolioCta,
});

export const PortfolioCtaExperiment = () => {
  const featureFlag = useFlag({
    name: 'mono-portfolio-dashboard-cta',
  });

  return <>{featureFlag.variant.name === 'variant' && <PortfolioCta />}</>;
};
